import React, { Component } from "react";

class KnoaCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_checked: props.isChecked ?? false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const checked = this.props.isChecked !== undefined
        ? !this.props.isChecked
        : !this.state.is_checked;

    // Update internal state if uncontrolled
    if (this.props.isChecked === undefined) {
      this.setState({ is_checked: checked });
    }

    // Delegate to appropriate callback
    const {
      handleUserAttributesUpdate,
      handleProjectReportsUpdate,
      handleAddToProjectUpdateCheckbox,
      handleCheckboxUpdate,
      handleSelectionForALL,
      label,
      number
    } = this.props;

    if (handleUserAttributesUpdate) {
      handleUserAttributesUpdate(label, checked);
    } else if (handleProjectReportsUpdate) {
      handleProjectReportsUpdate(number, checked);
    } else if (handleAddToProjectUpdateCheckbox) {
      handleAddToProjectUpdateCheckbox(number, checked);
    } else if (handleCheckboxUpdate) {
      handleCheckboxUpdate(number, checked);
    } else if (handleSelectionForALL) {
      handleSelectionForALL(checked);
    }
  }

  render() {
    const {
      isChecked,
      number,
      label,
      isEnabled = true,
      inline,
      srOnlyLabel = false
    } = this.props;

    const checked = isChecked !== undefined
        ? isChecked
        : this.state.is_checked;

    const id = `cb:${number}`;
    const wrapperClass = inline === "selectALL"
        ? "form-check form-check-inline checkbox-select-all-row"
        : inline
            ? "form-check form-check-inline"
            : "form-check";

    return (
        <div className={`checkbox-cell-wrapper ${wrapperClass}`}>
          <input
              className="form-check-input"
              type="checkbox"
              id={id}
              checked={checked}
              onChange={this.handleClick}
              disabled={!isEnabled}
          />
          <label className={`form-check-label ${srOnlyLabel ? "sr-only" : ""}`} htmlFor={id}>
            {label}
          </label>
        </div>
    );
  }
}

export default KnoaCheckbox;